import * as React from 'react'

export function RoomsMancave(props) {
  return (
    <svg viewBox='0 0 32 32' xmlns='http://www.w3.org/2000/svg' {...props}>
      <path
        d='M27 13.934a1 1 0 110-2 1 1 0 010 2m-3-3a1 1 0 110-2 1 1 0 010 2M24 17a1 1 0 11-.002-1.998A1 1 0 0124 17m-3-3.066a1 1 0 110-2 1 1 0 010 2m-11.037 0h-1v1c0 .55-.45 1-1 1s-1-.45-1-1v-1h-1c-.55 0-1-.45-1-1s.45-1 1-1h1v-1c0-.55.45-1 1-1s1 .45 1 1v1h1c.55 0 1 .45 1 1s-.45 1-1 1M24.357 7H8.576C5.191 7 2 9.698 2 12.934v8.461C2 23.49 4.064 25 5.942 25c1.507 0 2.926-.957 3.479-2.282l1.901-4.722h9.356l2.541 4.722c.754 1.325 1.706 2.181 3.199 2.181 2.077 0 3.582-1.409 3.582-3.504v-8.461C30 9.698 27.543 7 24.357 7'
        fill='currentColor'
        fillRule='evenodd'
      />
    </svg>
  )
}
